import { roundToTwoDecimals } from './round-to-two-decimals';

function clampPosition(value) {
  return Math.min(100, Math.max(0, value));
}

export const normalizePosition = (position) => ({
  x: roundToTwoDecimals(clampPosition(position.x)),
  y: roundToTwoDecimals(clampPosition(position.y)),
});
